import React, {Component} from 'react';
import IconWarning from '../style/icon/IconWarning'

class DeviceRelay extends Component {
  handleClick(dev) {
    this.props.onClick(dev)
  }

  render() {
    const {icon, device} = this.props
    return <div onClick={() => this.handleClick(device)}>
      <span >{icon}</span>
      {
        !device.Disconnected
          ? <div className="value">
              <span className="number" style={{
                  color: device.Color
                }}>{device.Temp}</span>
              <span className="unit">{device.Unit}</span>
            </div>
          : <div className="value">
              <span className="disconnected"><IconWarning/></span>
            </div>
      }
      <span style={{
          color: device.Color
        }}>{
          device.Name
            ? device.Name
            : 'None'
        }</span>
    </div>
  }
}

export default DeviceRelay;



// WEBPACK FOOTER //
// ./src/components/DeviceRelay.js